export * from './auth/auth';
export * from './auth/auth.module';
//# sourceMappingURL=auth.js.map


//////////////////
// WEBPACK FOOTER
// C:/firebase/gbord/~/angularfire2/auth.js
// module id = ../../../../angularfire2/auth.js
// module chunks = 3